module.exports = __webpack_public_path__ + "img/byberg.jpg";